module.exports = __webpack_public_path__ + "img/link.eb97fc3b.svg";